import {default as VtxExport} from './VtxExport';
import {default as VtxExport2} from './VtxExport.v2';

VtxExport.VtxExport2 = VtxExport2;

export default VtxExport;
export {VtxExport,VtxExport2};